import { render, staticRenderFns } from "./EduPms.vue?vue&type=template&id=d5e26020&scoped=true"
import script from "./EduPms.vue?vue&type=script&lang=js"
export * from "./EduPms.vue?vue&type=script&lang=js"
import style0 from "./EduPms.vue?vue&type=style&index=0&id=d5e26020&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e26020",
  null
  
)

export default component.exports